export default "__VITE_ASSET__B$InaU6N__"